import { TabPanel } from '@mui/lab';
import { CircularProgress, Paper, Stack, Typography } from '@mui/material';
import { Protect } from 'app/components';
import { MapTransportConditionFilterFullList, MapTransportEventList } from 'app/pages/Map';
import React from 'react';

const TabPanelEvent = ({ isFetchConditionLoading, transportSelectedItem }) => {
  return (
    <TabPanel value='event'>
      <Protect
        permissions='read'
        renderPermitted={() => (
          <React.Fragment>
            {!isFetchConditionLoading && transportSelectedItem.conditions.length !== 0 && (
              <Stack
                direction='row'
                sx={(theme) => ({
                  height: '100%',
                  borderTop: '1px solid',
                  borderColor: theme.palette.divider,
                  '& > .MuiPaper-elevation:first-of-type': {
                    width: '260px',
                    borderRight: '1px solid',
                    borderColor: theme.palette.divider,
                    borderRadius: '0',
                  },
                  '& > .MuiPaper-elevation:last-of-type': {
                    flex: 1,
                    bgcolor: 'background.default',
                    borderRadius: '0',
                  },
                })}>
                <Paper elevation={0}>
                  <MapTransportConditionFilterFullList />
                </Paper>
                <Paper elevation={0}>
                  <MapTransportEventList
                    renderEmpty={() => (
                      <Stack
                        direction='column'
                        alignItems='center'
                        justifyContent='center'
                        sx={(theme) => ({
                          width: '100%',
                          height: '100%',
                          padding: theme.spacing(2),
                        })}>
                        <Typography align='center' variant='body1' component='span'>
                          Ничего не найдено
                        </Typography>
                        <Typography align='center' color='text.secondary' variant='caption' component='span'>
                          Ни одно событие не соответствует выбранным фильтрам
                        </Typography>
                      </Stack>
                    )}
                  />
                </Paper>
              </Stack>
            )}
            {!isFetchConditionLoading && transportSelectedItem.conditions.length === 0 && (
              <Stack
                direction='column'
                alignItems='center'
                justifyContent='center'
                sx={(theme) => ({
                  width: '100%',
                  height: '100%',
                  padding: theme.spacing(2),
                })}>
                <Typography align='center' variant='body1' component='span'>
                  Здесь пока ничего нет
                </Typography>
                <Typography align='center' color='text.secondary' variant='caption' component='span'>
                  В этом разделе будет находиться журнал событий транспорта
                </Typography>
              </Stack>
            )}
            {isFetchConditionLoading && (
              <Stack
                direction='column'
                alignItems='center'
                justifyContent='center'
                sx={(theme) => ({
                  width: '100%',
                  height: '100%',
                  padding: theme.spacing(2),
                })}>
                <CircularProgress size={24} />
              </Stack>
            )}
          </React.Fragment>
        )}
        renderForbidden={() => (
          <React.Fragment>
            <Stack
              direction='column'
              alignItems='center'
              justifyContent='center'
              sx={(theme) => ({
                width: '100%',
                height: '100%',
                padding: theme.spacing(2),
              })}>
              <Typography align='center' variant='body1' component='span'>
                Доступ ограничен
              </Typography>
              <Typography align='center' color='text.secondary' variant='caption' component='span'>
                Под вашей учетной записью доступ ограничен
              </Typography>
            </Stack>
          </React.Fragment>
        )}
      />
    </TabPanel>
  );
};
export default TabPanelEvent;
